var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 599,
    height: 384,
    viewBox: "0 0 599 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.5 9C294.012 201.956 100.952 377.256 0 379.2L599 384C504.071 382.055 300.5 201.956 300.5 9Z",
    fill: "url(#paint0_linear_297_172)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.756 14.1612L297.634 13.4563C297.842 13.9843 298.091 14.4949 298.38 14.9833L298.547 15.2646L302.303 15.3908L302.49 15.1224C302.81 14.6543 303.093 14.1614 303.336 13.6484L305.163 14.4767C305.199 14.4935 305.242 14.4907 305.276 14.4693C305.31 14.4479 305.331 14.4108 305.332 14.3705L305.387 12.7289C305.405 12.1873 305.193 11.6632 304.803 11.2865L304.263 10.77C304.749 8.14144 304.435 4.62176 301.548 0.668056C301.404 0.464435 301.173 0.339677 300.924 0.330673C300.675 0.321673 300.436 0.429603 300.278 0.622383C297.138 4.37768 296.592 7.8711 296.897 10.5214L296.327 11.002C295.912 11.3496 295.664 11.8561 295.643 12.3966L295.588 14.0381C295.583 14.0808 295.602 14.1229 295.636 14.1484C295.671 14.1739 295.717 14.1788 295.756 14.1612ZM299.263 7.00381C299.276 6.62298 299.44 6.2631 299.719 6.00313C299.997 5.7431 300.368 5.60428 300.748 5.61718C301.129 5.63008 301.489 5.79363 301.75 6.07184C302.01 6.35005 302.149 6.72035 302.137 7.10112C302.124 7.4819 301.961 7.84229 301.683 8.1029C301.405 8.36351 301.035 8.50321 300.654 8.49116C300.272 8.47915 299.911 8.3155 299.65 8.0364C299.389 7.75729 299.249 7.38581 299.263 7.00381ZM299.317 18.4754C299.019 18.6067 298.76 18.813 298.565 19.0742C298.531 19.123 298.475 19.151 298.415 19.1483C298.342 19.1461 298.278 19.0984 298.255 19.0289C298.004 18.2621 297.658 16.5711 299.663 16.3225C299.687 16.3219 299.709 16.3313 299.725 16.3482C299.74 16.3651 299.748 16.3881 299.746 16.4111C299.661 16.9694 299.847 17.535 300.246 17.9344C300.294 17.9822 300.371 17.9847 300.422 17.9402C300.848 17.5728 301.074 17.025 301.032 16.4641C301.03 16.4396 301.04 16.4158 301.057 16.3991C301.075 16.3823 301.1 16.3746 301.124 16.3778C301.474 16.42 302.533 16.6372 302.609 17.7315C302.637 18.203 302.478 18.6662 302.166 19.0212C301.725 19.532 300.97 20.5388 300.995 21.3071C300.998 21.3712 300.966 21.432 300.911 21.4651C300.856 21.4982 300.787 21.4985 300.732 21.4656C300.184 21.1422 299.049 20.336 299.317 18.4754Z",
    fill: "#8D68FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_172",
    x1: 294,
    y1: -8.85714,
    x2: 294,
    y2: 384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#DBC8FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.1039c00cdc895c5b21618dd67cc0a84c.svg";
export { ForwardRef as ReactComponent };